import { AuthState } from './auth.state';
import { UserState } from './user.state';
import { FriendState } from './friend.state';
import { AppState } from './app.state';
import { NavigationState } from './navigation.state';
import { MediaUploadQueueState } from './media-upload-queue.state';

export const states = [AppState, AuthState, UserState, FriendState, MediaUploadQueueState, NavigationState];

export {AppState, AuthState, UserState, FriendState, MediaUploadQueueState, NavigationState};

// Global actions
export { InitAction } from './actions';
